import React, { useEffect, useState } from 'react';
import '../Styles/Parcel.scss';
import Hero from '../Hero';
import ProblemStatement from '../Problem';
import ProxyPNG from '../Styles/parcel.png';

const Parcel = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className='main-parcel-container'>
      
      {/* Project Overview Section */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Project Overview</strong></h1>
          <div className="main-parcel-product">
            <h2><strong>The Product</strong></h2>
            <p>
              To create a user-centric delivery service that ensures packages can be delivered seamlessly to users, regardless of their current or changing locations.
            </p>
            <div className="main-project">
              <h2><strong>Project Duration</strong></h2>
              <p>Feb - March 2025</p>
            </div>
          </div>
        </div>
        <div className="main-right-section">
          <img src={ProxyPNG} alt="Project Preview" />
        </div>
      </div>

      {/* Problem & Goal Section */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          {/* <h1><strong>Project Overview</strong></h1> */}
          <div className="main-parcel-product text-changer">
            <h2 className='text-changer'><strong>The Problem</strong></h2>
            <p className='text-changer'>
              For this project revolves around the inconvenience and lack of flexibility in traditional package delivery systems.
            </p>
          </div>
        </div>
        <div className="main-right-section text-changer">
          <div className="main-goal-section">
            <h2><strong>The Goal</strong></h2>
            <p>
              The goal for this project is to create a delivery service that prioritize flexibility, security, and convenience for user.
            </p>
          </div>
        </div>
      </div>

      {/* Role & Responsibilities */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          {/* <h1><strong>Project Overview</strong></h1> */}
          <div className="main-parcel-product">
            <h2><strong>My Role</strong></h2>
            <p>
              As the UX designer leading the project, I take ownership of every aspect of the design process, from user research and prototyping to testing and refinement. Leveraging the power of Replit AI, I streamline development, ensure efficiency, and introduce innovative solutions that enhance user experiences while aligning with project goals and objectives.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <h2><strong>Responsibilities</strong></h2>
          <p>
            Conducting interviews, paper and digital wireframing, low and high-fidelity prototyping, conducting usability studies, accounting for accessibility, iterating on designs and responsive design.
          </p>
        </div>
      </div>

      {/* Understanding the User Intro */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1><strong>Understanding The User</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="text-changer">
            <h2><strong>User Research</strong></h2>
            <h2><strong>Personas</strong></h2>
            <h2><strong>Problems Statements</strong></h2>
            <h2><strong>User Journey Maps</strong></h2>
          </div>
        </div>
      </div>

      {/* User Research Summary */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>User Research: Summary</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p>
              For this project, we conducted a combination of user interviews, surveys, and usability tests to explore user behaviors, pain points, and preferences regarding flexible package delivery systems. Initially, we assumed that users primarily valued delivery speed above all else. However, the research revealed that flexibility and security are just as critical, especially for frequent travelers and individuals with dynamic schedules. The findings shifted our focus toward features like real-time address updates, transparent tracking, and secure package handover to meet these deeper user needs effectively.
            </p>
          </div>
        </div>
      </div>

      {/* Pain Points */}
      <div className="main-parcel-content text-changer bg-changer">
        <div className="main-left-section">
          <h1><strong>User Research: Pain Points</strong></h1>
          <div className="main-parcel-pain-point">
            <h2><strong>Pain Point</strong></h2>
            <p>
              Inflexibility in Delivery Locations<br />
              Users are limited to setting a fixed address during checkout, which doesn’t accommodate dynamic or mobile lifestyles.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>Pain Point</strong></h2>
            <p>
              Missed Deliveries<br />
              Many users experience frustration when packages are delivered while they are not present at the specified location, leading to delays and rescheduling.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>Pain Point</strong></h2>
            <p>
              Lack of Real-Time Updates<br />
              Users often find it challenging to track packages accurately or make modifications to the delivery location or timing.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>Pain Point</strong></h2>
            <p>
              Security Concerns<br />
              There is a significant worry about package being delivered to incorrect individuals or left in unsecured areas, leading to mistrust in the delivery process.
            </p>
          </div>
        </div>
      </div>

      {/* Persona */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Persona: David</strong></h1>
          <div className="main-parcel-product">
            <h2><strong>Problem Statement</strong></h2>
            <p>
              [User name] is a [user characteristics] who needs [user need] because [insight].
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <h2><strong>David Smith</strong></h2>
            <img src={ProxyPNG} alt="Persona David" />
          </div>
        </div>
      </div>

      {/* User Journey Map */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>User Journey Map</strong></h1>
          <div className="main-parcel-product">
            <h2><strong>Problem statement:</strong></h2>
            <p>
              Alex Johnson, a digital nomad, struggles with missed deliveries and a lack of flexibility in traditional delivery systems. They need a service that provides real-time address updates, secure handovers, and reliable tracking to match their dynamic lifestyle.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="User Journey Map" />
          </div>
        </div>
      </div>

      {/* Starting the Design Intro */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1><strong>Starting The Design</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="text-changer">
            <h2><strong>Sitemap</strong></h2>
            <h2><strong>Digital Wireframes</strong></h2>
            <h2><strong>Low-fidelity Prototype</strong></h2>
            <h2><strong>Usability Studies</strong></h2>
          </div>
        </div>
      </div>

      {/* Sitemap */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Sitemap</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p>
              [Your notes about goals and thought process]
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Sitemap" />
          </div>
        </div>
      </div>

      {/* Digital Wireframes */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1 className='text-changer'><strong>Digital Wireframes</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p className='text-changer'>
              Using wireframes, I put my ideas on digital first and then started to make high-fidelity wireframes. After dozens of iterations, these are the wireframes that best represented user flow and met user needs.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Digital Wireframes" />
          </div>
        </div>
      </div>

      {/* Wireframe Variations */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Digital Wireframes screen size variations(s)</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p>
              [Your notes about goals and thought process + how you responded to and implemented peer feedback]
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Screen size variations" />
          </div>
        </div>
      </div>

      {/* Low-fidelity Prototype */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1 className='text-changer'><strong>Low-fidelity Prototype</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p className='text-changer'>
              I created a low-fidelity prototype from the user flow diagram and wireframes to test functionality before incorporating it into final design and ensure accessibility for end-users.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="Low-fidelity prototype" />
          </div>
        </div>
      </div>

      {/* Usability Parameters */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Usability Study: Parameters</strong></h1>
          <div className="main-parcel-pain-point">
            <h2><strong>Study Type:</strong></h2>
            <p>Unmoderated usability study</p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>Location:</strong></h2>
            <p>United States, remote</p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>Participants:</strong></h2>
            <p>5 participants</p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>Length:</strong></h2>
            <p>20-30 minutes</p>
          </div>
        </div>
      </div>

      {/* Usability Findings */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1 className='text-changer'><strong>Usability Study: Findings</strong></h1>
          <div className="main-parcel-pain-point">
            <h2 className='text-changer'><strong>Finding 1</strong></h2>
            <p className='text-changer'>
              Flexibility Challenges<br />
              Users found it difficult to update their delivery address after placing an order, leading to frustration when their plans or locations changed.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2 className='text-changer'><strong>Finding 2</strong></h2>
            <p className='text-changer'>
              Tracking Issues<br />
              Participants exposed a need for more transparent, real-time tracking that showed both package’s location and estimated time of delivery.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2 className='text-changer'><strong>Finding 3</strong></h2>
            <p className='text-changer'>
              Security Concerns<br />
              Users were concerned about packaged handover, highlighting the need for secure delivery features such as PIN verification or proof of delivery photos.
            </p>
          </div>
        </div>
      </div>

      {/* Refining Intro */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Refining The Design</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <h2><strong>Mockups</strong></h2>
            <h2><strong>High-fidelity Prototype</strong></h2>
            <h2><strong>Accessibility</strong></h2>
          </div>
        </div>
      </div>

      {/* Mockups Before & After */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1><strong>Mockups</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p className='text-changer'>
              [Your notes about goals and thought process + how you responded to and implemented peer feedback]
            </p>
          </div>
          <h2><strong>Before</strong></h2>
          <img src={ProxyPNG} alt="Before mockup" />
          <h2><strong>After</strong></h2>
          <img src={ProxyPNG} alt="After mockup" />
        </div>
      </div>

      {/* Mockup Screens Grid */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Mockup: Original screen size</strong></h1>
          <div className="mocks">
            <img src={ProxyPNG} alt="Mockup screen 1" />
            <img src={ProxyPNG} alt="Mockup screen 2" />
            <img src={ProxyPNG} alt="Mockup screen 3" />
            <img src={ProxyPNG} alt="Mockup screen 4" />
          </div>
        </div>
      </div>

      {/* High-Fidelity Prototype */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1 className='text-changer'><strong>High-Fidelity Prototype</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p className='text-changer'>
              After finalizing the low-fidelity prototype, I worked on creating the final designs with the goal of making them simple and intuitive. The main color theme I used was blue because it’s a very powerful color that symbolizes strength, power, and action. I thought it was very representative of the persona’s character.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <img src={ProxyPNG} alt="High fidelity prototype" />
          </div>
        </div>
      </div>

      {/* Accessibility Considerations */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Accessibility Considerations</strong></h1>
          <div className="main-parcel-pain-point">
            <h2><strong>1</strong></h2>
            <p>
              Clear Navigation<br />
              The interface is designed with intuitive navigation and clear labels to accommodate users of varying technical abilities.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>2</strong></h2>
            <p>
              Assistive Technology<br />
              The platform is fully compatible with screen readers and voice commands to ensure inclusivity for users with visual or physical impairments.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2><strong>3</strong></h2>
            <p>
              Contrast and Text Size<br />
              High-contrast color schemes and adjustable text sizes are implemented to improve readability for all users, including those with visual impairments.
            </p>
          </div>
        </div>
      </div>

      {/* Going Forward Intro */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1><strong>Going Forward</strong></h1>
          <div className="main-parcel-product">
            <h2><strong></strong></h2>
            <p></p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="text-changer">
            <h2><strong>Takeaways</strong></h2>
            <h2><strong>Next Steps</strong></h2>
          </div>
        </div>
      </div>

      {/* Takeaways */}
      <div className="main-parcel-content">
        <div className="main-left-section">
          <h1><strong>Takeaways</strong></h1>
          <div className="main-parcel-product">
            <h2><strong>Impact</strong></h2>
            <p>
              The designs received positive feedback, with a study participant stating, "The flexibility and real-time tracking features solve such a common issue—this would make my life so much easier!" This highlights the potential of the designs to address user pain points effectively and improve delivery experiences.
            </p>
          </div>
        </div>
        <div className="main-right-section">
          <div className="main-right-user-section">
            <h2><strong>What I learned</strong></h2>
            <p>
              I learned the importance of prioritizing user flexibility and security in delivery services. Understanding user pain points, such as missed deliveries and lack of real-time updates, highlighted the need for adaptable and transparent solutions. This process deepened my appreciation for user-centered design and reinforced how thoughtful features can significantly improve user satisfaction and trust.
            </p>
          </div>
        </div>
      </div>

      {/* Next Steps */}
      <div className="main-parcel-content bg-changer">
        <div className="main-left-section">
          <h1><strong>Next Steps</strong></h1>
          <div className="main-parcel-pain-point">
            <h2 className='text-changer'><strong>1</strong></h2>
            <p className='text-changer'>
              The next steps for this project would involve conducting additional usability tests to refine key features like real-time address updates and secure delivery verification.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2 className='text-changer'><strong>2</strong></h2>
            <p className='text-changer'>
              Based on user feedback, we would enhance the interface for even greater accessibility and user-friendliness.
            </p>
          </div>
          <div className="main-parcel-pain-point">
            <h2 className='text-changer'><strong>3</strong></h2>
            <p className='text-changer'>
              Implementing a pilot program would help gather real-world insights to further validate the design and ensure it meets diverse user needs effectively.
            </p>
          </div>
        </div>
      </div>

      {showScrollButton && (
        <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to Top">
          ↑ Top
        </button>
      )}
    </div>
  );
};

export default Parcel;